import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Rocket, TrendingUp } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function DondeEstasSection() {
  const {
    lang
  } = useLanguage();
  const cards = [{
    id: 'creando',
    icon: <Rocket size={24} color="#5a4579" data-id="element-86" />,
    title: lang === 'es' ? 'Estoy creando mi negocio' : 'I am creating my business',
    description: lang === 'es' ? 'Tienes una idea clara y necesitas la estructura legal y digital para lanzarla al mercado.' : 'You have a clear idea and need the legal and digital structure to launch it to the market.',
    bullets: lang === 'es' ? ['Registro de LLC y obtención de EIN', 'Creación de landing page profesional', 'Configuración de email corporativo'] : ['LLC registration and EIN acquisition', 'Professional landing page creation', 'Corporate email setup'],
    cta: lang === 'es' ? 'Ver plan de creación' : 'See creation plan',
    href: '#planes'
  }, {
    id: 'creciendo',
    icon: <TrendingUp size={24} color="#5a4579" data-id="element-87" />,
    title: lang === 'es' ? 'Ya tengo negocio y quiero crecer online' : 'I have a business and want to grow online',
    description: lang === 'es' ? 'Tu negocio ya funciona, pero tu presencia digital no refleja la calidad de tu trabajo.' : 'Your business is already running, but your digital presence does not reflect the quality of your work.',
    bullets: lang === 'es' ? ['Auditoría de sitio web actual', 'Rediseño de landing page profesional', 'Actualización de identidad visual'] : ['Current website audit', 'Professional landing page redesign', 'Visual identity refresh'],
    cta: lang === 'es' ? 'Ver Digital Upgrade' : 'See Digital Upgrade',
    href: '#digital-upgrade'
  }];
  return <section style={{
    background: '#FFFFFF',
    padding: '80px 24px',
    position: 'relative'
  }} data-id="element-88">
      <div className="max-w-6xl mx-auto" data-id="element-89">
        <div className="text-center mb-12" data-id="element-90">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(28px, 4vw, 40px)',
          fontWeight: 700,
          color: '#1a1020',
          lineHeight: 1.2,
          marginBottom: '16px'
        }} data-id="element-91">
            {lang === 'es' ? '¿Dónde estás tú?' : 'Where are you right now?'}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} style={{
          fontSize: '16px',
          color: '#6b5f78',
          maxWidth: '600px',
          margin: '0 auto'
        }} data-id="element-92">
            {lang === 'es' ? 'Identifica tu etapa actual y descubre cómo podemos ayudarte a dar el siguiente paso.' : 'Identify your current stage and discover how we can help you take the next step.'}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-93">
          {cards.map((card, idx) => <motion.div key={card.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2 + idx * 0.1
        }} className="flex flex-col h-full" style={{
          background: '#f7f4fb',
          borderRadius: '24px',
          padding: '40px',
          border: '1px solid rgba(90,69,121,0.08)'
        }} data-id="element-94">
              <div className="flex items-center justify-center" style={{
            width: '56px',
            height: '56px',
            background: '#FFFFFF',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(90,69,121,0.08)',
            marginBottom: '24px'
          }} data-id="element-95">
                {card.icon}
              </div>

              <h3 style={{
            fontSize: '22px',
            fontWeight: 800,
            color: '#1a1020',
            marginBottom: '12px',
            lineHeight: 1.3
          }} data-id="element-96">
                {card.title}
              </h3>

              <p style={{
            fontSize: '15px',
            color: '#6b5f78',
            lineHeight: 1.6,
            marginBottom: '32px'
          }} data-id="element-97">
                {card.description}
              </p>

              <div className="flex-grow" data-id="element-98">
                <ul className="space-y-4 mb-8" data-id="element-99">
                  {card.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-100">
                      <span className="flex items-center justify-center flex-shrink-0 mt-1" style={{
                  width: '20px',
                  height: '20px',
                  background: 'rgba(90,69,121,0.1)',
                  borderRadius: '50%',
                  color: '#5a4579'
                }} data-id="element-101">
                        <Check size={12} strokeWidth={3} data-id="element-102" />
                      </span>
                      <span style={{
                  fontSize: '15px',
                  color: '#374151',
                  lineHeight: 1.5
                }} data-id="element-103">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>

              <a href={card.href} className="group inline-flex items-center justify-between w-full transition-all" style={{
            background: '#FFFFFF',
            border: '1px solid rgba(90,69,121,0.15)',
            borderRadius: '12px',
            padding: '16px 20px',
            color: '#5a4579',
            fontWeight: 700,
            fontSize: '15px'
          }} onMouseEnter={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.borderColor = '#5a4579';
            el.style.boxShadow = '0 4px 12px rgba(90,69,121,0.08)';
          }} onMouseLeave={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.borderColor = 'rgba(90,69,121,0.15)';
            el.style.boxShadow = 'none';
          }} data-id="element-104">
                {card.cta}
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" data-id="element-105" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}